import dynamic from 'next/dynamic'
import { Footer } from '@fe-toolkit/web-components/ssr'
import { footerLinks } from '@fe-toolkit/utility'

// A separate chunk, so pages with the Brand Refresh flag off don't download
// feds-ui and Tamagui.
const BrandRefreshFooter = dynamic(() => import('./BrandRefreshFooter'))

// Shared by next/dynamic `loading`, the FederatedComponentBoundary fallback and
// the errorLoadRemote registry (mfOfflineHandlingPlugin.js), so the degraded UI
// is identical whichever failure mode fires.
export default function FallbackFooter({
  isBrandRefresh = false,
}: {
  isBrandRefresh?: boolean
}) {
  if (isBrandRefresh) {
    return <BrandRefreshFooter />
  }

  return <Footer links={footerLinks} />
}
